import { render, staticRenderFns } from "./DriverStatus.vue?vue&type=template&id=be09838a&scoped=true&"
import script from "./DriverStatus.vue?vue&type=script&lang=js&"
export * from "./DriverStatus.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatus.vue?vue&type=style&index=0&id=be09838a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be09838a",
  null
  
)

export default component.exports